import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Servicio } from '../models/servicio';
import { ServicioService } from '../services/servicio.service';
@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: ['./servicios.component.css']
})
export class ServiciosComponent implements OnInit {

  models: Servicio[];

  constructor(private modelService: ServicioService, private formBuilder: FormBuilder) {
    this.models = [];
  }

  ngOnInit() {

    this.onSubmit();
  }

  onSubmit() {
    this.modelService.getAll().subscribe(val => {
      this.models = val;
    });
  }


}
